import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { Star } from 'lucide-react';

const TESTIMONIALS = [
  { text: 'Väldigt pedagogisk lärare, som har tålamod och gör lektionerna motiverande.', author: 'Miriam', role: 'Elev' },
  { text: 'Jag tycker att läraren har ett pedagogiskt sätt att undervisa. Han förklarar tajweed tydligt.', author: 'Sugule', role: 'Förälder' },
  { text: 'Ustadh Ismail was very patient and helpful with Tajweed and proper pronunciation.', author: 'Tasneem & Mohammed Amkor', role: '' },
  { text: 'Jag tycker att lektionerna med Ustadh Ismail är väldigt givande, han är mån om att du ska läsa med korrekt tajweed och han fick mig att inte kunna läsa från mushaf till att kunna göra det på fåtal lektioner med tydlig struktur och planering.', author: 'Abdifatah', role: 'Elev' },
];

const TestimonialsSection = () => {
  const { language } = useLanguage();
  const sv = language === 'sv';

  return (
    <section className="py-24" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-4xl font-bold mb-3" style={{ color: 'var(--text-primary)' }}>
            {sv ? 'Vad våra elever och föräldrar säger' : 'What Our Students and Parents Say'}
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <div key={i} className="pricing-card !p-6" data-testid={`testimonial-${i}`}>
              <div className="flex gap-0.5 mb-4">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} className="text-gold fill-gold" />)}
              </div>
              <p className="text-sm mb-5 leading-relaxed italic" style={{ color: 'var(--text-secondary)' }}>
                "{t.text}"
              </p>
              <p className="text-xs font-medium" style={{ color: 'var(--text-muted)' }}>
                — {t.author}{t.role ? `, ${t.role}` : ''}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
